import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-profile-icon',
    templateUrl: './profile-icon.component.html',
    styleUrls: ['./profile-icon.component.scss'],
    standalone: false
})
export class ProfileIconComponent implements OnInit {
  @Input() src?: string;
  @Input() size: number = 40;

  constructor() { }

  ngOnInit(): void {
  }

  // imgタグに指定したsrcが404だった場合のデフォルト画像表示用
  setDefaultProfileIcon(event: any): void {
    event.target.src = '/assets/icon-profile-default.svg';

    // デフォルト画像も404だった場合にonerrorイベントが無限ループするのでonerrorイベントを削除
    event.target.removeAttribute('onerror');
  }
}
